module.exports = __webpack_public_path__ + "static/media/gallery-5.e99a46e4.jpg";